.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-4);
  margin-bottom: var(--spacing-5);
  flex-wrap: wrap;
}

.search {
  flex: 0 1 320px;
  min-width: 220px;
}

.actions {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}
